import { useState, useLayoutEffect, useRef } from "react";
import { SERVER_URL } from "../../util/url";
import { CSVLink } from "react-csv";

import { useLocation } from "react-router-dom";

import "./recipe.css";

function Recipe() {
    const location = useLocation();
    const recipeName = location.pathname.substring(22);
    const [recipe, setRecipe] = useState({});
    const [oldRecipe, setOldRecipe] = useState([]);
    const [allVersionRecipes, setAllVersionRecipes] = useState([]);
    const [setPoint, setSetPoint] = useState([]);
    const [workOrders, setWorkOrders] = useState([]);
    const [matchRecipes, setMatchRecipes] = useState(false);
    const [dataIsLoaded, setDataIsLoaded] = useState(false);
    const selectedVersion = useRef();

    const fetchRecipe = async (signal) => {
        await fetch(SERVER_URL + "/recipes?recipe_name=" + location.pathname.substring(22), {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    recipe.name = data.data[0].recipe_name;
                    recipe.op_id = data.data[0].op_id;
                    recipe.status = data.data[0].status;
                    setRecipe(data.data[0]);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const fetchNominalSetpoint = async (signal) => {
        setPoint.length = 0;
        await fetch(SERVER_URL + "/nominalsp?recipe_name=" + recipe.name, {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    data.data.forEach((item) => {
                        const param = item["parameter"].split(" impostato");
                        setPoint.push({
                            parameter: param[0],
                            tolerance: item["tolerance"],
                            value: item["value"],
                            unit: item["unit"],
                            realtime_value: "Non presente",
                        });
                    });
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const fetchActualSetpoint = async (signal) => {
        function getIndexOfObject(name) {
            for (let i = 0; i < setPoint.length; i++) {
                if (setPoint[i].parameter === name) {
                    return i;
                }
            }
            return -1;
        }

        await fetch(SERVER_URL + "/realtimesp?plant_id=cambiano&machine_id=" + recipe["op_id"], {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data != null) {
                    data.data.forEach((item) => {
                        var param;
                        if (item["parameter"].includes("rilevato")) {
                            param = item["parameter"].split(" rilevato");
                        } else {
                            param = item["parameter"].split(" rilevata");
                        }
                        const index = getIndexOfObject(param[0]);
                        if (index !== -1) {
                            setPoint[index].realtime_value = item["value"];
                        } else {
                            setPoint.push({
                                parameter: param[0],
                                value: "Non presente",
                                unit: item["unit"],
                                realtime_value: item["value"],
                                tolerance: "Non definita",
                            });
                        }
                    });
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
        setSetPoint([...setPoint]);
    };

    const fetchWorkOrders = async (signal) => {
        await fetch(SERVER_URL + "/workorders?recipe_name=" + recipe["name"], {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data != null) {
                    setWorkOrders(data.data);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const fetchAllVersion = async () => {
        await fetch(SERVER_URL + "/recipes/versions?name=" + recipe.name, {
            method: "GET",
        })
            .then((response) => response.json())
            .then((data) => {
                if (data != null) {
                    setAllVersionRecipes(data.data);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const handleMatch = async () => {

        if(allVersionRecipes.length <= 1) return null;

        oldRecipe.length = 0;
        setMatchRecipes(true);
        setTimeout(async () => {
            const name = recipeName.substring(0, recipeName.length - 2) + selectedVersion.current.value + "X";

            await fetch(SERVER_URL + "/nominalsp?recipe_name=" + name, {
                method: "GET",
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data !== null) {
                        data.data.forEach((item) => {
                            const param = item["parameter"].split(" impostato");
                            oldRecipe.push({
                                parameter: param[0],
                                tolerance: item["tolerance"],
                                value: item["value"],
                                unit: item["unit"],
                            });
                        });
                    }
                })
                .catch((err) => {
                    if (err.name === "AbortError") {
                        console.log("request aborted");
                    } else {
                        console.log(err);
                    }
                });

            setOldRecipe([...oldRecipe]);
        }, 100);
    };

    const loadData = async (signal) => {
        await fetchRecipe(signal);
        fetchAllVersion();
        await fetchNominalSetpoint(signal);
        if (recipe.status === "ACTIVE") {
            await fetchActualSetpoint(signal);
        }
        await fetchWorkOrders(signal);
        setDataIsLoaded(true);
    };

    useLayoutEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        loadData(signal);

        var interval;
        if (recipe.status === "ACTIVE") {
            interval = setInterval(() => {
                fetchActualSetpoint(signal);
            }, 60000);
        }

        return () => {
            controller.abort();
            clearInterval(interval);
        };
    }, []);

    return (
        <div className={"recipe p-5 bg-light " + (dataIsLoaded ? null : "d-flex align-items-center")}>
            {dataIsLoaded ? (
                <div>
                    <div>
                        <div className="d-flex">
                            <p className="fw-bold fs-5 text-secondary me-3">Tutte le ricette &nbsp; &gt;</p>
                            <p className="fw-bold fs-5 text-primary"> {recipeName} </p>
                        </div>
                        <div className="d-flex mb-3">
                            <p className="fw-bold fs-4 my-auto me-4"> Setpoint List </p>
                            {recipe["machine_comunication"] === 1 && (
                                <button type="button" className="btn btn-light d-flex my-2">
                                    <p className="fs-6 m-0 me-3"> INVIA RICETTA ALLA MACCHINA </p>
                                    <span className="material-symbols-outlined">electric_bolt</span>
                                </button>
                            )}
                        </div>
                        <div className="d-flex my-2">
                            <p className={"m-0 my-auto " + (!matchRecipes ? "text-decoration-underline" : null)} onClick={handleMatch} style={{ cursor: !matchRecipes ? "pointer" : null }}>
                                CONFRONTA
                            </p>
                            <div className="card my-2 mx-3">
                                <p className="m-0 px-4 py-1">
                                    {" "}
                                    {recipe["recipe_name"]} v.{recipe["version"]}
                                </p>
                            </div>
                            {allVersionRecipes.length <= 1 && (
                                <div className="d-flex my-2">
                                    <p className="m-0 my-auto fst-italic"> Non ci sono versioni precedenti </p>
                                </div>
                            )}
                            {matchRecipes && allVersionRecipes.length > 1 && (
                                <>
                                    <p className="m-0 my-auto mx-3"> VS </p>
                                    <div className="my-2 mx-3">
                                        <select className="form-select" aria-label="Default select example" ref={selectedVersion} onChange={handleMatch}>
                                            {allVersionRecipes.map((r) => {
                                                if (r.version !== recipe["version"])
                                                    return (
                                                        <option value={r.version}>
                                                            {" "}
                                                            {r.name} v.{r.version}{" "}
                                                        </option>
                                                    );
                                                return null;
                                            })}
                                        </select>
                                    </div>
                                    <p className="text-decoration-underline m-0 my-auto" onClick={() => setMatchRecipes(false)} style={{ cursor: "pointer" }}>
                                        ANNULLA
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-9">
                                <div className="card p-3">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">PARAMETRI</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">VALORE</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">TOLLERANZA</p>
                                                </th>
                                                {recipe["status"] === "ACTIVE" && !matchRecipes && (
                                                    <th scope="col">
                                                        <p className="m-0 fs-6 text-secondary">REAL TIME</p>
                                                    </th>
                                                )}
                                                {matchRecipes && (
                                                    <th scope="col">
                                                        <p className="m-0 fs-6 text-secondary text-danger">VALORE PRECEDENTE</p>
                                                    </th>
                                                )}
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">UNITÀ</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {setPoint.map((item, index) => {
                                                if(matchRecipes && item["value"] === "Non presente") return null;
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <p className="m-0 mt-1"> {item["parameter"]} </p>
                                                        </td>
                                                        <td>
                                                            {" "}
                                                            <p className="m-0 mt-1"> {item["value"]} </p>
                                                        </td>
                                                        <td>
                                                            <p className="m-0 mt-1"> {item["tolerance"] !== null ? item["tolerance"] + " %" : "Non presente"} </p>
                                                        </td>
                                                        {matchRecipes && (
                                                            <td>
                                                                {oldRecipe.map((s, index) => {
                                                                    if (s.parameter === item["parameter"]) {
                                                                        return (
                                                                            <p key={index} className={"m-0 mt-1" + (s.value !== item["value"] ? " text-danger" : " text-secondary")}>
                                                                                {s.value}
                                                                            </p>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                            </td>
                                                        )}
                                                        {recipe["status"] === "ACTIVE" && !matchRecipes && (
                                                            <td>
                                                                {" "}
                                                                <p className="m-0 mt-1 text-success"> {item["realtime_value"]} </p>
                                                            </td>
                                                        )}
                                                        <td>
                                                            {" "}
                                                            <p className="m-0 mt-1"> {item["unit"]} </p>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className="card p-4">
                                    <p className="fw-bold fs-4"> Ordini di lavoro associati </p>
                                    {workOrders.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <div className="d-flex">
                                                    <p className="my-1 text-primary"> {item["id"]} </p>
                                                    <div className="mx-4">
                                                        {item["status"] === "STARTING" ? (
                                                            <span className="badge text-bg-success"> {item["status"]} </span>
                                                        ) : item["status"] === "RUNNING" ? (
                                                            <span className="badge text-bg-warning"> {item["status"]} </span>
                                                        ) : (
                                                            <span className="badge text-bg-danger"> {item["status"]} </span>
                                                        )}
                                                    </div>
                                                </div>
                                                {item["status"] === "CLOSED" ? <p className="text-secondary"> {item["stop_date"]} </p> : <p className="text-secondary"> {item["start_date"]} </p>}
                                            </div>
                                        );
                                    })}
                                    <button type="button" className="btn btn-outline-light">
                                        <CSVLink data={workOrders} filename={"workorders.csv"} className="text-decoration-none text-dark">
                                            ESPORTA STORICO ODL IN CSV
                                        </CSVLink>
                                    </button>
                                </div>
                                <p className="my-3 fw-bold fs-4">Codici aggiuntivi</p>
                                <div className="card p-3">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">PARAMETRI</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">VALORI</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th>
                                                    <p className="m-0 fs-6">Stampo</p>
                                                </th>
                                                <td>
                                                    <p className="m-0 fs-6"> {recipe["mould_id"]} </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <p className="m-0 fs-6">Prodotto/Articolo</p>
                                                </th>
                                                <td>
                                                    <p className="m-0 fs-6"> {recipe["product_id"]} </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <p className="m-0 fs-6">Mescola</p>
                                                </th>
                                                <td>
                                                    <p className="m-0 fs-6"> {recipe["compound"]} </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <p className="m-0 fs-6">Pressa</p>
                                                </th>
                                                <td>
                                                    <p className="m-0 fs-6"> {recipe["op_id"]} </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <p className="m-0 fs-6">Numero cavità</p>
                                                </th>
                                                <td>
                                                    <p className="m-0 fs-6"> {recipe["number_cavities"]} </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box mx-auto">
                    <div className="text-center">
                        <div className="spinner-border text-primary my-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Caricamento dei dati ...</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Recipe;
